export default "__VITE_ASSET__66d8fc90__"